module.exports = __webpack_public_path__ + "static/project-6-8c657e2b399e6a77c906c75a78738bfe.jpg";